import InvoiceInput from './InvoiceInput';
import InvoiceManage from './InvoiceManage';
import InputSettlement from './InputSettlement';
import AuthManage from './AuthManage';
import InvoiceCompare from './InvoiceCompare';
import InvoiceCompareDetail from './InvoiceCompare/UI.CompareDetail';
import OutputSettlement from './OutputSettlement';
import CompanyRegister from './CompanyRegister';
import Help from './Help';
import GroupInfo from './GroupInfo';
import AppSearch from './AppSearch';

export default {
    
    /** 发票录入 */
    InvoiceInput,

    /** 发票管理 */
    InvoiceManage,

    //进项结算单
    InputSettlement,

    /** 销项结算单 */
    OutputSettlement,
    
    /** 勾选认证 */
    AuthManage,

    /** 发票对比 */
    InvoiceCompare,

    /** 发票对比 */
    InvoiceCompareDetail,

    /** 公司注册 */
    CompanyRegister,
    
    /** 帮助中心 */
    Help,
    
    /** 集团资料 */
    GroupInfo,

    /** 搜索app侧边栏 */
    AppSearch,
};



// WEBPACK FOOTER //
// ./src/display/apps/index.ts